import { AxiosResponse } from "axios";
import { Base } from "./bases/base.service";

export default class PaymentService {
  public buy(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("payment/buy", params);
  }
  public getInvoiceDetail(invoice: string): Promise<AxiosResponse<any>> {
    return Base().get(`payment/invoice/${invoice}`);
  }
}
